import { HttpInterceptorFn } from '@angular/common/http';

/**
 * HTTP Interceptor that adds credentials (cookies) to all API requests
 * This is required for the backend to send and receive HTTP-only cookies
 */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  // Clone the request and add withCredentials flag
  const clonedRequest = req.clone({
    withCredentials: true,
  });

  return next(clonedRequest);
};
